import { Component, AfterViewInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'toolbar-map',
  templateUrl: './toolbar-map.component.html',
  styleUrls: ['./toolbar-map.component.scss']
})
export class ToolbarMapComponent implements AfterViewInit {
  @Output() onOptimizeClick = new EventEmitter<any>();
  @Output() onPainRoutClick = new EventEmitter<any>();
  @Output() onSearchClick = new EventEmitter<any>();
  constructor() {

  }
  ngAfterViewInit(): void {
  }
  optimizeClick() {
    this.onOptimizeClick.emit();
  }
  paintRouteClick() {
    this.onPainRoutClick.emit();
  }
  searchClick() {
    this.onSearchClick.emit();
  }

}
